import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import RoomSearch from './RoomSearch.js';
import CardRoom from './CardRoom.js';
import PreBook from './PreBook.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import HelpContainer from '../HelpContainer';
import GoBackButton from '../../components/GoBackButton/index.jsx';
import Dialog from '../../components/Dialog/index.jsx';


let cancelToken;
let state;
let tokenSession;
// let arrDates = []

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class RoomsContainer extends Component {


    getInitState = () => {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return {
            center: null,
            centerQuery: "",
            centers: [],
            date: moment(tomorrow, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            duration: "4",
            durations: [],
            error: "",
            isTomorrow: "",
            isSearching: false,
            reservationId: "",
            rooms: null,
            search: null,
            room_id: null,
            time: "08:00",
            IsFast: false,
            IsRoom: false,
            book: null,
            GoToPay: false,
            showModalRoomUnavailable: false,
        };
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        if (props.center) {
            state.center = props.center;
            state.centerQuery = props.centerQuery;
            state.centers = props.centers;
        }
        state.reservationId = "";
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        // this.setState({
        //     room_id: null,
        //     IsFast: false,
        //     IsRoom: false,
        //     book: null,
        //     GoToPay: false,
        // }, () => {
        //     state = this.state;
        // })
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.reservationId !== prevState.reservationId) {
            const getBookRoom = () => this.getBooK({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.state.reservationId,
            });

            this.setState({
                IsFast: true,
            }, getBookRoom);
        }

        if (this.state.book !== prevState.book) {
            $('#btnSuccess').click()
        }
    }

    reload = () => {
        this.getDurations({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });
    }

    getCenters = (params) => {
        this.props.post(
            "/getCenters",
            params,
            (response) => this.didGetCenters(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    // Obtiene las duraciones de las salas
    getDurations = (params) => {

        this.props.post(
            "/getDurations",
            params,
            (response) => this.didGetDurations(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    getRooms = (params) => {
        this.props.post_store(
            "/getRooms",
            params,
            (response) => this.didGetRooms(response),
            (error) => {
                this.setState({ isSearching: false });
                this.props.handleErrorResponse(error);
            },
            cancelToken,
            () => this.setState({ isSearching: false })
        );
    }

    bookRoom = (params) => {
        this.props.post_store(
            "/bookSala",
            params,
            (response) => this.didBookRoom(response),
            (error) => this.didBookRoomError(error),
            cancelToken
        );
    }

    bookRoomPromise = (params) => {
        return new Promise((resolve, reject) => {
            this.props.post_store(
                "/bookSala",
                params,
                (response) => resolve(response),
                (error) => reject(error),
                cancelToken
            );
        })
    }

    getBooK = (params) => {
        this.props.post_store(
            "/getBook",
            params,
            (response) => this.didGetBook(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetCenters = (response) => {
        this.setState({ centers: response });
        this.handleOptionUpdate();
    }

    getDurations = (params) => {
        this.props.post(
            "/getDurations",
            params,
            (response) => this.didGetDurations(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetDurations = (response) => {
        let duration = this.state.duration;
        duration = duration ? duration : response[0].id;
        this.setState({
            duration: duration,
            durations: response
        });
    }

    didGetRooms = (response) => {
        const { t } = this.props;
        const rooms = response

        const callback = () => {
            if (this.state.rooms.length > 0) {
                $('html, body').animate({
                    scrollTop: $('#rooms').offset().top - $('.navbar').height() - 20
                }, 800);
            } else {
                this.setState({ error: t('dashboard.reservations.no_results') });
            }
        };

        this.setState({
            isSearching: false,
            rooms: rooms.map((r) => {
                r.room_type = this.state.roomType;
                return r;
            }),
            search: {
                center: this.state.center ? this.state.center : this.props.center,
                date: this.state.date,
                duration: this.state.duration,
                time: this.state.time
            }
        }, callback);
    }

    didBookRoom = (response) => {
        const reservationId = response.reservation_id
        this.setState({ reservationId: reservationId });
    }

    didBookRoomError = (error) => {
        const { t } = this.props;
        // alert(t('dashboard.reservations.msg'));
        this.setState({ showModalRoomUnavailable: true });
    }

    didGetBook = (response) => {
        this.setState({ book: response })
    }

    handleOptionUpdate = () => {
        if ($("#center-results").children().length) {
            $("#center-results").css("display", "");
        } else {
            $("#center-results").css("display", "none");
        }
    }

    handleCenterClick = (center) => {
        this.setState({
            center: center,
            centerQuery: center.name
        });
    }

    handleDateChange = (date) => {
        const new_date = moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
        this.setState({
            date: new_date,
            rooms: null
        });
    }

    // ? for Search Component
    handleDurationChange = (event) => {
        this.setState({
            duration: event.target.value,
            rooms: null
        });
    }

    // ? for Search Component
    handleClearError = () => {
        this.setState({ error: "" });
    }

    // ? for Search Component
    handleRoomSearch = (event) => {
        event.preventDefault();

        this.setState({
            error: "",
            isSearching: true
        });

        this.getRooms({
            centro_id: this.state.center ? this.state.center.id : this.props.center.id,
            date: moment(this.state.date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            duration: this.state.duration,
            start_time: this.state.time,
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        });
    }

    handleCenterSearch = (event) => {
        const getCenters = () => this.getCenters({
            query: this.state.centerQuery,
            token_id: this.props.getTokenId()
        });

        this.setState({
            center: null,
            centerQuery: event.target.value
        }, getCenters);
    }

    handleTimeChange = (event) => {
        this.setState({
            time: event.target.value,
            rooms: null
        });
    }

    handleBookRoom = (event) => {
        this.setState({
            room_id: event,
        }, () => this.handleBookService()
            .then((data) => {
                this.setState({ reservationId: data.reservation_id });
            })
            .catch((error) => {
                this.setState({ showModalRoomUnavailable: true });
            }));
    }

    handleBookRoomPlus = (room_id) => {
        // this.handleBookService()
        this.setState({
            room_id,
            IsRoom: true,
        }, () => {
            this.handleBookService()
                .then((data) => {
                    this.setState({ reservationId: data.reservation_id }, () => {
                        this.props.history.push(`${URI_VENTA_EN_LINEA}/room/${this.state.room_id}/${this.state.reservationId}`)
                    });
                })
                .catch((error) => {
                    this.setState({ showModalRoomUnavailable: true });
                })
        });
    };

    handleBookService = (event) => {
        return this.bookRoomPromise({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            center_id: this.state.center.id,
            date: moment(this.state.date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
            start_time: this.state.time,
            duration: this.state.duration,
            sala_id: this.state.room_id
        });
    }

    handleGoToPay = (event) => {
        this.setState({ GoToPay: true });
    }

    renderRoomSearch = () => {
        return (
            <RoomSearch
                center={this.state.center ? this.state.center : this.props.center}
                centerQuery={this.state.centerQuery ? this.state.centerQuery : this.props.centerQuery}
                centers={this.state.centers}
                date={this.state.date}
                duration={this.state.duration}
                durations={this.state.durations}
                error={this.state.error}
                handleCenterClick={this.handleCenterClick}
                handleCenterSearch={this.handleCenterSearch}
                handleDateChange={this.handleDateChange}
                handleDurationChange={this.handleDurationChange}
                handleClearError={this.handleClearError}
                handleRoomSearch={this.handleRoomSearch}
                handleTimeChange={this.handleTimeChange}
                isSearching={this.state.isSearching}
                roomType={this.state.roomType}
                coworkType={this.state.coworkType}
                objInputsCowork={this.state}
                rooms={this.state.rooms}
                time={this.state.time} />
        );
    }

    renderRoomCard = () => {
        return (
            <CardRoom
                rooms={this.state.rooms}
                duration={this.state.duration}
                handleBookRoom={this.handleBookRoom}
                handleBookRoomPlus={this.handleBookRoomPlus}
            />
        )
    }

    renderRoomResevation = (props) => {
        if (this.state.book) {
            return (
                <PreBook
                    tokenId={this.props.getTokenId()}    
                    reservation={this.state.book}
                    handleGoToPay={this.handleGoToPay}
                    post_store={this.props.post_store}
                />
            )
        } else {
            return false
        }
    }

    rebderHelperContainer = () => {
        return (
            <HelpContainer />
        )
    }

    render() {
        if (this.state.GoToPay) {
            return <Redirect to={{
                pathname: `${URI_VENTA_EN_LINEA}/book/${this.state.reservationId}`
            }} />;
        }
        const { t } = this.props;
        return (
            <div className="content-resvations">
                <div className="container-resvations-title">
                    {/* <div className={this.props.user.memberId !== 1 ? "col-md-6" : "col-md-12"}> */}
                    <GoBackButton />
                    <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
                    {/* </div> */}
                </div>
                <div>
                    <div className="content-resvations-search">
                        {this.renderRoomSearch()}
                    </div>
                    <div className="content-resvations-content">
                        {this.state.rooms ? (
                            <div id="rooms">
                                {this.renderRoomCard()}
                            </div>
                        ) : null}
                    </div>
                </div>
                <div className="resvation_expancion">
                    {this.state.reservationId && this.state.IsFast ? (
                        this.renderRoomResevation()
                    ) : null}
                </div>
                {/* <div className="form-group"> */}
                {/* <Link to={URI_VENTA_EN_LINEA}>
                        <button
                            className="btn btn-primary btn-search-resvations-ruturn"
                            type="button"
                            style={{ background: "#36414E !important ", border: "#3cc", margin: "0px" }}>
                            <span>
                                Regresar
                            </span>
                        </button>
                    </Link> */}
                {/* <button
                        className="btn btn-lg btn-primary btn-singup-help"
                        type="button"
                        style={{ marginInline: "0px" }}
                        onClick={() => $('#btnSuccessHelp').click()}
                    >
                        <span>
                            ¿Necesitas ayuda?
                        </span>
                    </button> */}
                {/* </div> */}
                {this.rebderHelperContainer()}
                {
                    this.state.showModalRoomUnavailable &&
                    <Dialog
                        title={t('dashboard.reservations.msg')}
                        handleDismiss={() => this.setState({ showModalRoomUnavailable: false })}>
                        <p>{t('dashboard.reservations.msg')}</p>
                    </Dialog>
                }
            </div>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(RoomsContainer);



// WEBPACK FOOTER //
// ./src/store/Reservation/RoomContainer.js